import { PaginationMeta } from '@recruitee/http-types';

export const isAllPagesLoaded = (pagination: PaginationMeta) =>
  pagination.totalCount <= pagination.page * pagination.limit;
